export enum HeroSectionImageSize {
  Full = 'full',
  Original = 'original',
}
